import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IRole } from '../../shared/booking/model/role.model';
import { IFeature } from '../../shared/booking/model/feature.model';
import { SERVER_API_URL } from '../../app.constants';
import { createRequestOption } from '../../shared/util/request-util';

type EntityResponseType = HttpResponse<IRole>;
type EntityArrayResponseType = HttpResponse<IRole[]>;
type EntityArrayResponseType2 = HttpResponse<IFeature[]>;

@Injectable({ providedIn: 'root' })
export class RoleService {
  public resourceUrl = SERVER_API_URL + 'api/roles';
  public resourceFeaturesUrl = SERVER_API_URL + 'api/roles-features';
  public resourceUrlCompany = SERVER_API_URL + 'api/roles-company';

  constructor(protected http: HttpClient) {}

  create(role: IRole): Observable<EntityResponseType> {
    return this.http.post<IRole>(this.resourceUrl, role, { observe: 'response' });
  }

  update(role: IRole): Observable<EntityResponseType> {
    return this.http.put<IRole>(this.resourceUrl, role, { observe: 'response' });
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<IRole>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }
  getAllForCompany(): Observable<EntityArrayResponseType> {
    return this.http.get<IRole[]>(`${this.resourceUrlCompany}`, { observe: 'response' });
  }

  getAllFeatures(): Observable<EntityArrayResponseType2> {
    return this.http.get<IFeature[]>(`${this.resourceFeaturesUrl}`, { observe: 'response' });
  }

  getAllFeaturesForRole(id: number): Observable<EntityArrayResponseType2> {
    return this.http.get<IFeature[]>(`${this.resourceFeaturesUrl}/${id}`, { observe: 'response' });
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IRole[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.http.delete(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }
}
